"use strict";

function _getOuts(hand) {
    return +(hand.size >= 4) && _calculateOuts(hand);
}

function _calculateOuts(hand) {
    if (hand.isTwoPairs()) {
        return 4;
    } else if (hand.isThreeOfKind()) {
        return hand.size === 4 ? 3 : 6;
    }

    return 0;
}

module.exports = function (hand) {
    return _getOuts(hand);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/tx-holdem/browser/src/draw-combination/full-house.js
// module id = 35
// module chunks = 0